import Model from "~/models/_Model";
import Role from "./Role";
import Permission from "./Permission";

export default class User extends Model {
  // Set the resource route of the model
  resource() {
    return "users";
  }

  relations() {
    return {
      roles: Role,
      permissions: Permission,
    };
  }

  loadPermissionsFromRole() {
    let permissions = [];
    this.roles.forEach((role) => {
      // Gather role's permissions
      if (role.permissions != null && role.permissions.length) {
        role.permissions.forEach((perm) => {
          permissions.push(perm);
        });
      }
    });
    this.permissions = permissions;
  }

  hasRole(roleToCheck) {
    return this.role_names.includes(roleToCheck);
  }

  hasRoleIn(rolesToCheck) {
    let role_names = this.role_names;
    let role_found = false;
    rolesToCheck.forEach((role) => {
      if (role_names.includes(role)) {
        role_found = true;
      }
    });
    return role_found;
  }

  hasPermission(permissionToCheck) {
    return this.permission_names.includes(permissionToCheck);
  }

  hasPermissionIn(permissionsToCheck) {
    let permission_names = this.permission_names;
    let permission_found = false;
    permissionsToCheck.forEach((perm) => {
      if (permission_names.includes(perm)) {
        permission_found = true;
      }
    });
    return permission_found;
  }

  get role_names() {
    if (!this.roles || this.roles.length == 0) {
      return [];
    }
    return this.roles.map((role) => role.name);
  }

  get permission_names() {
    if (!this.permissions || this.permissions.length == 0) {
      // Check if roles exist
      if (!this.roles || this.roles.length == 0) {
        return [];
      }
      this.loadPermissionsFromRole();
    }
    return this.permissions.map((perm) => perm.name);
  }
}
